import { Box, Text, Flex, Button } from '@chakra-ui/react'
import React from 'react';
import NavBar from '../../components/NavigationBar'
import Footer from '../../components/Footer';
import TeamDisplay from '../../components/Contact/TeamDisplay';
import { Gallery } from '../../components/Gallery/Gallery';
import { images } from './logan-land-data'

const LoganLand = () => {

  return (
    <Box maxWidth={"1250px"} mx={"auto"} bgColor={'#ffffff'}>
    <NavBar />

    <Box
      as="section"
      py="12"
      position="relative"
      h={{ base: '217px', md: '572px' }}
      bgImage="/Logan Land Website Banner.png"
      bgSize="cover"
      bgPosition="center"
    >

      <Button
        as="a"
        href="https://www.crexi.com/properties/2725809/utah-logan-land"
        target="_blank"
        rel="noopener noreferrer"
        zIndex={'1'}
        marginTop={['215px','200px','420px']}
        letterSpacing={'1px'}
        fontSize={['14px','16px','18px']}
        height={['50px','50px','50px']}
        width={['200px','200px','200px']}
        marginLeft={['0px','0px','63%']}
        backgroundColor={'#CBA689'}
        color={'#FFFFFF'}
        fontFamily={'montserrat, sans-serif'}
        _hover={{ backgroundColor: '#a2765e' }}
      >View Listing</Button>

      <Box
        maxW={{ base: 'xl', md: '7xl' }}
        mx="auto"
        px={{ base: '6', md: '8' }}
        h="full"
        zIndex={1}
        position="relative"
      >
      </Box>
      <Box
        display={{ base: 'none', md: 'block' }}
        position="absolute"
        zIndex={2}
        w="full"
        bottom="0"
        py="4"
      >
      </Box>

        <Text
          paddingTop={'3px'}
          paddingLeft={'10px'}
          style={{ position: 'absolute', bottom: '0', left: '0', right: '0' }}
          bg="gray.600"
          color="#F2F2F2"
          opacity={'.7'}
          height={['28%','30%','25%']}
          pl={'20%'}
          textAlign="left"
          fontFamily={'montserrat, sans-serif'}
        >
        </Text>
    </Box>

    <Text
      fontSize={['16px','16px','30px']}
      fontFamily={'montserrat, sans-serif'}
      align={['center','left','left']}
      pl={['0%','10%','10%']}
      position="relative"
      mt={['-55px','-59px','-120px']}
      color={'#F2F2F2'}
      fontWeight={'bold'}
    >Logan Land</Text>
    <Text
      fontSize={['13px','16px','22px']}
      fontFamily={'montserrat, sans-serif'}
      align={['center','left','left']}
      pl={['0%','10%','10%']}
      color={'#F2F2F2'}
      position="relative"
      mb={['100px','0px','100px']}
    >Logan, UT</Text>

    <Box
      as="section"
      py="12"
      position="relative"
      marginTop={['165px','130px','75px']}
      marginBottom={'75px'}
      marginLeft={'10%'}
      marginRight={'10%'}
      h="auto"
      bgColor={'#EAE6DC'}
      overflow={'auto'}
    >
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4" color={'#475253'}>
        THE OFFERING
      </Text>

      <Flex justifyContent="space-between" marginTop={'30px'} flexDirection={['column','row','row']}>
        <Box flex="3">
          <Text fontFamily={'montserrat, sans-serif'} fontSize={["15px","16px","17px"]} lineHeight={["22px","25px","27px"]} mb="4" marginLeft={'10%'} marginRight={'10%'} align={'left'}>
          Marcus & Millichap is pleased to present Logan Land. The county around it keeps adding people. About 145,000 people live here, 2,383 more than a year ago, a 1.7% growth rate that outpaces Utah as a whole. Unemployment sits at 3.1%, tied for the lowest in the state and well under the national average. A few minutes east, Utah State's 29,831 students form a steady baseline of rental demand underneath the county's own growth.
          </Text>
          <Text fontFamily={'montserrat, sans-serif'} fontSize={["15px","16px","17px"]} lineHeight={["22px","25px","27px"]} mb="4" marginLeft={'10%'} marginRight={'10%'} align={'left'}>
          This site puts that demand one block west of Main Street in downtown Logan, with 165 feet of frontage on 100 West, the city's north-south bypass. The frontage carries TC-2 zoning at 30 units per acre, with the rear parcels zoned MR-12 at 12 per acre. A few different plans have already been drawn for the site, including multifamily concepts with ground-floor commercial. While you entitle, the existing 4-plex pays $3,000 a month toward your carry.
          </Text>
        </Box>
        <Box flex="2">
          <Box maxW="400px" marginRight={['25px','50px','50px']} marginLeft={['25px','0px','0px']} fontFamily={'montserrat, sans-serif'} marginTop={['25px','0px','0px']}>

            <Box display="flex" alignItems="center" justifyContent="space-between" mb="2">
              <Text fontSize={["16px","16px","18px"]} fontWeight="bold">Property Type</Text>
              <Text fontSize={["16px","16px","18px"]}>Land</Text>
            </Box>
            <Box borderBottom="1px solid" borderColor={'#CBA689'} mb="2"></Box>

            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Text fontSize={["16px","18px","19px"]} fontWeight="bold">Parcel Size</Text>
              <Text fontSize={["16px","18px","19px"]}>2.21 acres</Text>
            </Box>

          </Box>
        </Box>
      </Flex>
    </Box>

    <Box p="4">
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4" color={'#475253'}>
        INVESTMENT HIGHLIGHTS
      </Text>
      <Flex justifyContent="space-evenly" fontSize={['15px','18px','18px']} flexDirection={['column','column','row']}>
        <Box flex="1" p="4" maxW={['96%','93%','27%']} marginLeft={['0px','0px','50px']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>A Growing County</span> - 145,000 people, growing 1.7% a year, faster than Utah as a whole. Unemployment sits at 3.1%, tied for the lowest in the state, with Utah State's 29,831 students as a permanent rental-demand baseline.
          </Text>
        </Box>
        <Box flex="1" p="4" maxW={['96%','93%','27%']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>One Block Off Main Street</span> - One block west of Main Street with 165 feet on the 100 West bypass and 82.5 feet on 500 North, five parcels that only work as one sale.
          </Text>
        </Box>
        <Box flex="1" p="4" maxW={['96%','93%','27%']} marginRight={['0px','0px','50px']}>
          <Text fontFamily={'Noto Sans, sans-serif'}>
            <span style={{ color: '#CBA689', fontWeight: 'bold' }}>Plans Already Drawn</span> - A few different plans have been drawn for the site, including multifamily with ground-floor commercial. The frontage is TC-2 at 30 units per acre, the rear parcels MR-12 at 12 per acre.
          </Text>
        </Box>
      </Flex>
    </Box>

    <Box>
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" paddingTop={'75px'} color={'#475253'}>
        GALLERY
      </Text>
      <Box
        mb={'35px'}
        maxW="80%"
        mx="auto"
        px={{ base: '4', md: '8', lg: '12' }}
        py={{ base: '6', md: '8', lg: '12' }}
      >
        <Gallery images={images} />
      </Box>
    </Box>

    <Box
      as="section"
      marginTop={'55px'}
      py="12"
      position="relative"
      h={{ base: '475px', md: '330px' }}
      bgImage="/listing-team-background.png"
      bgSize="cover"
      bgPosition="center"
      bgColor={'#EAE6DC'}
      _after={{
        content: `""`,
        display: 'block',
        w: 'full',
        h: 'full',
        position: 'absolute',
        inset: 0,
        zIndex: 0,
      }}
    >
      <Text fontFamily={'montserrat, sans-serif'} fontSize={['20px','23px','32px']} fontWeight="bold" textAlign="center" mb="4">
        ADVISORY TEAM
      </Text>
      <Text fontFamily={'Noto Sans, sans-serif'} fontSize={["","2xl","2xl"]} fontWeight="bold" textAlign="center" mb="4">
        Marcus & Millichap
      </Text>
      <Flex flexDirection={['column','column','row']} justifyContent={'center'} mt={'1px'} alignItems={'center'}>
        <TeamDisplay
          imageSrc="/evan-clark.png"
          name="Evan Clark"
          title="Associate"
          number="801.736.2632"
          email="evan.clark@marcusmillichap.com"
          license="UT 10187590-SA00"
        />
        <TeamDisplay
          imageSrc="/jake-miles-circle.png"
          name="Jake Miles"
          title="Senior Associate"
          number="801.736.2654"
          email="jake.miles@marcusmillichap.com"
          license="UT 11449836-SA00, ID: SP53647"
        />
      </Flex>
    </Box>

    <Footer />
    </Box>
  );
};

export default LoganLand;
